<template>
  <div>
    <header class="member-header">
      <h4 class="m-0 member-header-title">
        {{ user.name }}({{ user.JPNSEQ }})
        <span class="mx-2">|</span> 營業月份：{{ getFormatBusinessMonth }}
        <span class="mx-2">|</span> {{ user.qualificationType }} (責<span
          class="act-circle"
          v-if="user.ACT == 1"
        ></span
        >)<span class="mx-2">|</span>
        <b-button size="sm" v-b-modal.changeIDModal>變更ID</b-button>
      </h4>
    </header>
    <b-modal id="changeIDModal" title="變更ID" hide-footer>
      <template>
        <div>
          <button
            v-for="alias in userAliasList"
            @click="changeAlias(alias)"
            :key="alias.JPNSEQ"
            :class="[
              'btn',
              'btn-block',
              { 'btn-primary': alias.JPNSEQ !== user.JPNSEQ },
              { 'btn-warning': alias.JPNSEQ === user.JPNSEQ },
            ]"
          >
            {{ alias.JPNSEQ }}
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { getBusinessMonth, getUserAliasList } from "../../api/fordaysHelpers";
export default {
  name: "MemberHeader",
  computed: {
    ...mapGetters(["getAuth"]),
    getFormatBusinessMonth() {
      return moment(getBusinessMonth(), "YYYYMM").format("YYYY/MM");
    },
  },
  data() {
    return {
      user: {},
      userAliasList: [],
    };
  },
  methods: {
    changeAlias(alias) {
      const JPNSEQ = alias.JPNSEQ;
      window.localStorage.setItem("FordaysJPNSEQ", JPNSEQ);
      window.location.reload();
    },
  },
  mounted() {
    const vm = this;
    const user = vm.getAuth.user;
    vm.user = user;
    getUserAliasList(user.email)
      .then((userAliasList) => {
        vm.userAliasList = userAliasList;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
<style lang="scss">
.member-header-title {
  font-size: 20px;
}
.act-circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: rgb(15, 185, 15);
  border-radius: 50%;
}
</style>